export default "__VITE_ASSET__694d1e78__"